(() => {
  const root = document.querySelector('#go-collection-root');
  if (!root) return;

  const sectionId = root.getAttribute('data-go-section-id');
  if (!sectionId) return;

  const CACHE = new Map();
  let ctrl = null;
  let t = null;

  // Keep these selectors SMALL & stable (only what you need to swap)
  const SELECTORS = {
    grid: '#ProductGridContainer',              // Dawn/most themes
    count: '.collection-product-count',         // product count text
    active: '.active-facets, .facets__summary', // active filters row (theme-dependent)
    facetsForm: 'facet-filters-form, .facets'   // optional: if you want sidebar to update too
  };

  const qs = (sel, ctx = document) => ctx.querySelector(sel);

  function setLoading(on) {
    document.documentElement.classList.toggle('go-filter-loading', !!on);
  }

  function buildSectionURL(url) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function swapFromHTML(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Replace grid
    const newGrid = qs(SELECTORS.grid, doc);
    const curGrid = qs(SELECTORS.grid);
    if (newGrid && curGrid) curGrid.replaceWith(newGrid);

    // Replace product count (if present)
    const newCount = qs(SELECTORS.count, doc);
    const curCount = qs(SELECTORS.count);
    if (newCount && curCount) curCount.replaceWith(newCount);

    // Replace active facets row (if present)
    const newActive = qs(SELECTORS.active, doc);
    const curActive = qs(SELECTORS.active);
    if (newActive && curActive) curActive.replaceWith(newActive);

    // OPTIONAL: If you want the left sidebar checkboxes to stay in sync,
    // replace the facets container too (heavier; only enable if you need it)
    // const newFacets = qs(SELECTORS.facetsForm, doc);
    // const curFacets = qs(SELECTORS.facetsForm);
    // if (newFacets && curFacets) curFacets.replaceWith(newFacets);

    // Re-run any theme behaviors that attach to product cards
    document.dispatchEvent(new CustomEvent('go:collection:updated'));
  }

  async function goNavigate(url, push = true) {
    // Debounce rapid multi-clicks
    clearTimeout(t);
    t = setTimeout(async () => {
      const pageURL = new URL(url, window.location.origin).toString();

      // Instant from cache
      if (CACHE.has(pageURL)) {
        if (push) history.pushState({}, '', pageURL);
        swapFromHTML(CACHE.get(pageURL));
        return;
      }

      // Abort in-flight
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();

      setLoading(true);
      try {
        const res = await fetch(buildSectionURL(pageURL), {
          signal: ctrl.signal,
          headers: { 'Accept': 'text/html' }
        });
        if (!res.ok) throw new Error('Fetch failed');
        const html = await res.text();

        CACHE.set(pageURL, html);
        if (push) history.pushState({}, '', pageURL);
        swapFromHTML(html);
      } catch (e) {
        if (e.name !== 'AbortError') {
          // Fallback: if anything goes wrong, do a normal nav (never dead-end the user)
          window.location.href = pageURL;
        }
      } finally {
        setLoading(false);
      }
    }, 80);
  }

  // Intercept clicks on your custom filterbar links
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a.go-pill, a.go-t');
    if (!a) return;
    if (!a.href) return;

    e.preventDefault();
    goNavigate(a.href, true);
  });

  // Back/forward support
  window.addEventListener('popstate', () => {
    goNavigate(window.location.href, false);
  });

})();
